var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-archive-card-version-panel"},[_vm._v(" Obecna wersja: "+_vm._s(_vm.currentVersionDateTime)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }